<template>
  <v-container id="login" class="fill-height justify-center" tag="section" justify="center" align="center">
    <v-img id="login-footer" src="@/assets/powered-by-norven.svg" />
    <v-row align="center" justify="end" no-gutters>
      <v-col cols="12" sm="6" class="align-center d-flex justify-center">
        <img src="@/assets/animacao-logo-geon.gif" width="150%" alt="Logotipo Geon" />
      </v-col>
      <v-col cols="12" sm="6">
        <wizard />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EsqueceuSenha',
    components: {
      Wizard: () => import('@/components/login/ForgotPasswordWizard.vue')
    }
  };
</script>

<style scoped>
  #login-footer {
    margin: 0px 0px 16px 32px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 300px;
  }
  #login-header {
    margin: 16px 32px 0px 0px;
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
  }
</style>
